import { useState, useMemo } from 'react';
import { ArrowLeft, Search } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { blogPosts, categories } from '../../data/blogPosts';
import {
  BlogWrapper,
  BlogHeader,
  BlogTitle,
  BlogSubtitle,
  SearchSection,
  SearchInputWrapper,
  SearchInput,
  CategoryFilter,
  CategoryButton,
  BlogGrid,
  BlogCard,
  BlogImage,
  BlogContent,
  BlogDate,
  BlogCardTitle,
  BlogExcerpt,
  ReadMore,
  NoResults
} from './styles';

const Blog = () => {
  const [searchTerm, setSearchInput] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredPosts = useMemo(() => {
    return blogPosts.filter(post => {
      const matchesSearch = post.title.includes(searchTerm) || 
                           post.excerpt.includes(searchTerm);
      const matchesCategory = activeCategory === 'all' || 
                             post.categorySlug === activeCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchTerm, activeCategory]);

  return (
    <BlogWrapper>
      <BlogHeader>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <BlogTitle>מאמרים ועדכונים</BlogTitle>
          <BlogSubtitle>
            טיפים, עצות ומידע שימושי בנושא משכנתאות ומימון נדל"ן
          </BlogSubtitle>
        </motion.div>
      </BlogHeader>

      <SearchSection>
        <SearchInputWrapper>
          <Search />
          <SearchInput 
            placeholder="חיפוש מאמרים..." 
            value={searchTerm}
            onChange={(e) => setSearchInput(e.target.value)}
          />
        </SearchInputWrapper>

        <CategoryFilter>
          {categories.map(category => (
            <CategoryButton
              key={category.slug}
              active={activeCategory === category.slug}
              onClick={() => setActiveCategory(category.slug)}
            >
              {category.name}
            </CategoryButton>
          ))}
        </CategoryFilter>
      </SearchSection>

      <BlogGrid as={motion.div} layout>
        <AnimatePresence mode='popLayout'>
          {filteredPosts.map(post => (
            <BlogCard 
              key={post.id}
              as={Link}
              to={`/blog/${post.slug}`}
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
            >
              <BlogImage 
                image={post.image} 
                fallbackImage="/images/blog/default.jpg"
              />
              <BlogContent>
                <BlogDate>{post.date} | {post.category}</BlogDate>
                <BlogCardTitle>{post.title}</BlogCardTitle>
                <BlogExcerpt>{post.excerpt}</BlogExcerpt>
                <ReadMore>
                  קרא עוד <ArrowLeft />
                </ReadMore>
              </BlogContent>
            </BlogCard>
          ))}
        </AnimatePresence>
      </BlogGrid>

      {filteredPosts.length === 0 && (
        <NoResults>
          לא נמצאו מאמרים התואמים את החיפוש שלך
        </NoResults>
      )}
    </BlogWrapper>
  );
};

export default Blog;
